import axios from '@/plugins/axios'

const state = {
    reseller: {},
}

const getters = {
    reseller: state => state.reseller,
    name: state => state.reseller.trade_name,
    isWhiteLabel: state => !!state.reseller.partner_whitelabel,
}

const actions = {
    async getReseller({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get('/auth/me')
                .then(res => {
                    commit('setReseller', res.data.reseller)

                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    setReseller({ commit }, data) {
        commit('setReseller', data)
    },
}

const mutations = {
    setReseller(state, reseller) {
        state.reseller = reseller
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
